import { useTranslation } from "react-i18next";
import styles from "./Directions.module.css";

interface IDirections {
    description: string;
    isMobile: boolean;
}

const Directions: React.FC<IDirections> = (props) => {
    const { t } = useTranslation();
    var directionsArray = props.description.split("\n");
    const directionsList = directionsArray.map((ingredient: string, index: number) => (
        <li key={`direction-${index}`}>{ingredient}</li>
    ));

    return (
        <div className={props.isMobile ? `${styles.containerMobile}` : `${styles.containerDesktop}`}>
            <h2 className={styles.title}>{t("components.feature.directions")}:</h2>
            <div className={styles.directionsList}>
                <ol>{directionsList}</ol>
            </div>
        </div>
    );
};

export default Directions;
